import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        lightDefault: "bg-primary/10 text-secondary-foreground hover:bg-primary/20",
        destructive: "bg-destructive/10 text-destructive hover:bg-destructive/20",
        outline:
          "border border-input hover:bg-accent hover:text-accent-foreground text-foreground disabled:bg-muted disabled:text-muted-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        accent: "bg-accent text-accent-foreground hover:bg-accent/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        navLinkGhost:
          "text-foreground hover:text-accent-foreground hover:bg-accent transition-opacity transition-duration-300 data-[status=active]:text-accent-foreground data-[status=active]:bg-accent",
        sidebarNavLink:
          "text-foreground/50 hover:text-foreground transition-opacity transition-duration-300 data-[status=active]:text-foreground data-[status=active]:bg-secondary",
        link: "underline-offset-4 hover:underline text-primary",
      },
      size: {
        default: "h-10 py-2 px-4",
        sm: "h-9 px-3 rounded-md",
        lg: "h-11 px-8 rounde-md",
        xs: "h-8 px-3 rounded-md text-xs",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);
